import { Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
// import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';

@Injectable({
  providedIn: 'root'
})
export class RouterService {

  constructor(
    // private localizeRouterService: LocalizeRouterService,
    private router: Router
  ) {
  }

  navigate(commands: any[], extras?: NavigationExtras | undefined) {
    // const result: any = this.localizeRouterService.translateRoute(commands);
    return this.router.navigate(commands, extras);
  }
}
